module.exports = __webpack_public_path__ + "img/ysq.24aa8bb2.png";